import React from 'react'
import { useParams } from 'react-router';
import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

function ContratDetails() {
const { id } = useParams();

return (
    <Box>
        <Typography variant="h5" gutterBottom>
            Détail du contrat (ID: {id})
        </Typography>
        <Box>
            <Typography variant="h6" gutterBottom>
                Heures du contrat
            </Typography>
            <Box>
                <Typography>Nombre d'heures Administrateur : 20</Typography>
                <Typography>Nombre d'heures Ingénieur : 15</Typography>
                <Typography>Nombre d'heures Technicien : 30</Typography>
            </Box>
        </Box>
        <Box mt={4}>
            <Typography variant="h6" gutterBottom>
                Matrice des compétences
            </Typography>
            <Box sx={{ overflowX: 'auto' }}>
                <Table sx={{ minWidth: 650 }} aria-label="matrice des compétences">
                    <TableHead>
                        <TableRow>
                            <TableCell>Compétence</TableCell>
                            <TableCell>Détail</TableCell>
                            <TableCell>Niveau d'intervention</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>Application</TableCell>
                            <TableCell>Installation, Configuration, Rédaction</TableCell>
                            <TableCell>Ingénieur</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Système</TableCell>
                            <TableCell>Création, Supervision</TableCell>
                            <TableCell>Administrateur</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Réseau</TableCell>
                            <TableCell>Maintenance, Support</TableCell>
                            <TableCell>Technicien</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Box>
        </Box>
    </Box>
)}

export default ContratDetails